import React, { useEffect } from 'react'

import { ExplicitChangeTextInput } from '../../../common/components/explicit-change-text-input'
import { Switch, SWITCH_TYPE } from '../../../common/components/switch'
import { usePageEditorContext } from '../../contexts/page-editor.context'
import { Accordion, AccordionSummary, AccordionDetails } from '../../editor/sidebar-accordion'
import { ManualBlockEditor } from '../../editor/manual-block-editor'
import { CategoryListEdit } from '../category-list-edit'
import { reportDataSetService } from '../../editor/report-data-set.service'
import { HeaderEditAccordion } from '../header-edit-accordion'
import { FooterEditAccordion } from '../footer-edit-accordion'
import { reportBlockService } from '../../blocks/report-block.service'
import { FilterEditAccordion } from '../filter-edit-accordion'
import { SplitChartFilterEditAccordion } from '../split-chart-filter-edit-accordion'

export const SankeyBlockEditSidebar = function ({ block }) {
  const pageEditorContext = usePageEditorContext() || {}

  const filterOptionLabels = reportDataSetService.getFilterOptionLabels(block)

  const modifyLabelsProps = function (pageEditorContext) {
    const props = pageEditorContext.currentEdit.block.props
    const dataLabels = reportDataSetService.getDataSetLabels(pageEditorContext.page, pageEditorContext.currentEdit.block.dataKey)

    if (isDeepEqual(dataLabels.stages, props.stageLabels)) {
      delete props.stageLabels
    }

    if (isDeepEqual(dataLabels.states, props.stateLabels)) {
      delete props.stateLabels
    }
  }

  useEffect(() => {
    pageEditorContext.updateCurrentEdit({ onBeforeSave: modifyLabelsProps })

    if (!block.dataKey) {
      return
    }

    const dataLabels = reportDataSetService.getDataSetLabels(pageEditorContext.page, block.dataKey)

    if (!Array.isArray(dataLabels.stages) || !Array.isArray(dataLabels.states)) {
      return
    }

    block.props.stageLabels = reportBlockService.getTheRightConfiguration(dataLabels.stages, block.props.stageLabels)
    block.props.stateLabels = reportBlockService.getTheRightConfiguration(dataLabels.states, block.props.stateLabels)
    updateBlock(block)
  }, [])

  function updateBlock (block) {
    pageEditorContext.registerUnsavedChanges()
    pageEditorContext.updateCurrentEdit({ block: { ...block } })
  }

  function getBlockProp (prop, defaultValue) {
    if (block.props[prop] === undefined) {
      return defaultValue
    } else {
      return block.props[prop]
    }
  }

  function setBlockProp (prop, value) {
    block.props[prop] = value
    updateBlock(block)
  }

  function getLabelsList (labels) {
    const values = labels.map((label, index) => ({
      value: index,
      label: label
    }))
    return [{ values, disableReorder: true }]
  }

  function handleLabelsChange (updated, propKey) {
    block.props[propKey] = updated[0].values.map(({ label }) => (label))
    updateBlock(block)
  }

  if (!block.dataKey) {
    return <div className="report-editor-sidebar">
      <Accordion square defaultExpanded={true}>
        <AccordionSummary>
          Other
        </AccordionSummary>
        <AccordionDetails>
          <div className="field-grid">
            <div className="full-width-field">
              <ManualBlockEditor block={block} onChange={updateBlock} />
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  }

  return <div className="report-editor-sidebar">
    <Accordion square defaultExpanded={true}>
      <AccordionSummary>
        Labels
      </AccordionSummary>
      <AccordionDetails>
        <div className="field-grid">
          <div className="full-width-field" data-qa="field-value-label">
            <ExplicitChangeTextInput
              size="medium"
              label="Value Label"
              value={getBlockProp('valueLabel', '')}
              onChange={(event) => {
                setBlockProp('valueLabel', event.target.value)
              }}
            />
          </div>
          <div className="full-width-field" data-qa="field-axis-label">
            <ExplicitChangeTextInput
              size="medium"
              label="Axis Label"
              value={getBlockProp('axisLabel', '')}
              onChange={(event) => {
                setBlockProp('axisLabel', event.target.value)
              }}
            />
          </div>
          {block.props.stageLabels &&
            <div className="full-width-field">
              <CategoryListEdit
                size="medium"
                hideCategoryDropdown={true}
                hideLabelToggles={true}
                listLabel="Stage Labels"
                categories={getLabelsList(block.props.stageLabels)}
                onChange={(updatedList) => {
                  handleLabelsChange(updatedList, 'stageLabels')
                }}
              />
            </div>
          }
          {block.props.stateLabels &&
            <div className="full-width-field">
              <CategoryListEdit
                size="medium"
                hideCategoryDropdown={true}
                hideLabelToggles={true}
                listLabel="State Labels"
                categories={getLabelsList(block.props.stateLabels)}
                onChange={(updatedList) => {
                  handleLabelsChange(updatedList, 'stateLabels')
                }}
              />
            </div>
          }
        </div>
      </AccordionDetails>
    </Accordion>
    {filterOptionLabels.filter(({ values, isSplitChartFilter }) => !isSplitChartFilter && values.length > 0).length > 0 && (
      <FilterEditAccordion block={block} />
    )}
    <SplitChartFilterEditAccordion block={block} />
    <HeaderEditAccordion block={block} />
    <FooterEditAccordion block={block} />
    <Accordion square>
      <AccordionSummary>
        Other
      </AccordionSummary>
      <AccordionDetails>
        <div className="field-grid">
          <div className="full-width-field">
            <div className="form-element-label-medium">Allow More Than One Filter</div>
            <Switch
              type={SWITCH_TYPE.MINI}
              isOn={getBlockProp('useControlBar', true)}
              onToggle={(event) => { setBlockProp('useControlBar', event.target.checked) }}
            />
          </div>
          <div className="full-width-field">
            <ManualBlockEditor block={block} onChange={updateBlock} />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  </div>
}

function isDeepEqual (val1, val2) {
  return JSON.stringify(val1) === JSON.stringify(val2)
}
